module.exports = __webpack_public_path__ + "static/media/digitalTransformation-min.2e638196.jpg";